import React, { useContext, useEffect, useState } from "react";
import Masonry, { ResponsiveMasonry } from "react-responsive-masonry";
import { CgDetailsMore } from "react-icons/cg";

import Project from "./Project";
import {
  Box,
  Button,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,
  useBreakpointValue,
} from "@chakra-ui/react";
import {
  HiOutlineChevronDoubleRight,
  HiOutlineChevronDown,
} from "react-icons/hi";
import { GetProjectsDetails } from "../../Services/firebase";
import { sortProjectsBasedOnOrders } from "../../utils";
import CustomButton from "../Common/CustomButton";
import { useLocation, useNavigate } from "react-router-dom";
import { GlobalContext } from "../GlobalContext";
import useCurrentLocation from "../../hooks/useCurrentLocation";
import Loader from "../Loader";
const categoriesObj = {
  all: "All projects",
  freelance: "Freelancing",
  personal: "Personal",
};
const Projects = () => {
  const { projects } = useContext(GlobalContext);
  const { isHomePage } = useCurrentLocation();

  const navigate = useNavigate();
  const screen = useBreakpointValue({
    base: "isMobile",
    sm: "isDesktop",
  });
  const [projectsData, setProjectsData] = useState([]);
  const [currentCategory, setCurrentCategory] = useState("all");
  const [filteredProjects, setFilteredProjects] = useState([]);

  useEffect(() => {
    if (projects?.length > 0) {
      setProjectsData(projects);
      const result = sortProjectsBasedOnOrders(projects, "all", isHomePage);
      setFilteredProjects(result);
    }
  }, [projects, isHomePage]);
  const handleFilteredProjects = (category) => {
    const result = sortProjectsBasedOnOrders(
      projectsData,
      category,
      isHomePage
    );
    setFilteredProjects(result);
    setCurrentCategory(category);
  };

  return (
    <Box>
      {/* title */}
      <Box mb="2rem" zIndex={10}>
        <Box
          color="#FAFAFA"
          display="flex"
          alignItems="center"
          pb="1rem"
          lineHeight="1.6"
        >
          <Text as="h2" fontSize="28px" fontWeight="600">
            Gallery of My Work
          </Text>
          {screen === "isDesktop" && (
            <>
              <Text
                mx="2"
                fontSize="26px"
                fontWeight="600"
                display={{ base: "none", md: "inline" }}
              >
                <HiOutlineChevronDoubleRight />
              </Text>
              {/* <Text
                fontSize="26px"
                fontWeight="600"
                display={{ base: "none", md: "inline" }}
              >
                Categories
              </Text>
              <Text mx="2" fontSize="26px" fontWeight="600">
                <HiOutlineChevronDoubleRight />
              </Text> */}
              <Menu>
                <MenuButton
                  variant="unstyled"
                  fontSize="24px"
                  fontWeight="600"
                  as={Button}
                  color="#FAFAFA"
                  isLoading={projectsData.length === 0}
                >
                  <Text
                    mt="0.1rem"
                    display="flex"
                    gap={1}
                    mx="2"
                    fontSize="26px"
                    fontWeight="600"
                  >
                    {categoriesObj[currentCategory]}
                    <HiOutlineChevronDown fontSize="1.25rem" />
                  </Text>
                </MenuButton>
                <MenuList
                  color="#FAFAFA"
                  zIndex={1000}
                  bg="linear-gradient(to top left,#1e293b,#312e81)"
                  letterSpacing="1px"
                  fontSize="1.1rem"
                >
                  <MenuItem
                    bg="transparent"
                    onClick={() => handleFilteredProjects("freelance")}
                  >
                    Freelancing
                  </MenuItem>
                  <MenuItem
                    bg="transparent"
                    onClick={() => handleFilteredProjects("personal")}
                  >
                    Personal
                  </MenuItem>
                  <MenuItem
                    bg="transparent"
                    onClick={() => handleFilteredProjects("all")}
                  >
                    All Projects
                  </MenuItem>
                </MenuList>
              </Menu>
            </>
          )}
        </Box>
        <Box
          w="40px"
          h="5px"
          borderRadius="3px"
          bg="linear-gradient(to right,#ffdb70,#ffbb5c)"
        />

        {screen === "isMobile" && (
          <Box
            color="#FAFAFA"
            display="flex"
            alignItems="center"
            mt="1rem"
            pb="1rem"
            lineHeight="1.6"
          >
            <Text mr="2" fontSize="28px" fontWeight="600">
              <HiOutlineChevronDoubleRight />
            </Text>
            {/* categories menu */}
            <Menu>
              <MenuButton
                variant="unstyled"
                fontSize="24px"
                fontWeight="600"
                as={Button}
                color="#FAFAFA"
                isLoading={projectsData.length === 0}
              >
                <Text
                  mt="0.1rem"
                  display="flex"
                  gap={1}
                  mx="2"
                  fontSize="26px"
                  fontWeight="600"
                >
                  {categoriesObj[currentCategory]}
                  <HiOutlineChevronDown fontSize="1.25rem" />
                </Text>
              </MenuButton>
              <MenuList
                color="#FAFAFA"
                zIndex={1000}
                bg="linear-gradient(to top left,#1e293b,#312e81)"
                letterSpacing="1px"
                fontSize="1.1rem"
              >
                <MenuItem
                  bg="transparent"
                  onClick={() => handleFilteredProjects("freelance")}
                >
                  Freelancing
                </MenuItem>
                <MenuItem
                  bg="transparent"
                  onClick={() => handleFilteredProjects("personal")}
                >
                  Personal
                </MenuItem>
                <MenuItem
                  bg="transparent"
                  onClick={() => handleFilteredProjects("all")}
                >
                  All Projects
                </MenuItem>
              </MenuList>
            </Menu>
          </Box>
        )}
      </Box>

      {/* projects list */}
      {filteredProjects && filteredProjects.length > 0 ? (
        <Box>
          <ResponsiveMasonry
            columnsCountBreakPoints={{ 350: 1, 768: 2, 900: 3 }}
          >
            <Masonry columnsCount={3} gutter="30px">
              {filteredProjects.map((projectDetails) => {
                return (
                  <Project
                    projectDetails={projectDetails}
                    key={projectDetails.proId}
                  />
                );
              })}
            </Masonry>
          </ResponsiveMasonry>
          {isHomePage && (
            <CustomButton
              text="More"
              icon={<CgDetailsMore fontSize="1.5rem" />}
              handleClick={() => {
                navigate("projects");
              }}
            />
          )}
        </Box>
      ) : (
        <Loader />
      )}
    </Box>
  );
};

export default Projects;
